import { cn } from 'cn';
import { ChevronDownIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useIsPhone } from '@/app/viewport';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';

/** "Key" eyebrow then chip plus one-sentence pairs; open on desktop, collapsed on the phone. */
export function Legend({ children, className }: { children: ReactNode; className?: string }) {
  const phone = useIsPhone();
  return (
    <Collapsible key={phone ? 'phone' : 'desktop'} defaultOpen={!phone} data-slot="legend" className={cn('rounded-xl border border-beam-line bg-beam-paper', className)}>
      <CollapsibleTrigger className="eyebrow group flex min-h-11 w-full items-center gap-2 px-4 text-left text-beam-text-muted md:min-h-9">
        Key
        <ChevronDownIcon aria-hidden="true" className="size-3.5 transition-transform duration-[140ms] group-data-[state=open]:rotate-180" />
      </CollapsibleTrigger>
      <CollapsibleContent className="px-4 pb-3">
        <dl className="flex flex-col gap-2 text-[13px] md:flex-row md:flex-wrap md:gap-x-6 md:gap-y-2">{children}</dl>
      </CollapsibleContent>
    </Collapsible>
  );
}

export function LegendItem({ term, children }: { term: ReactNode; children: ReactNode }) {
  return (
    <div className="flex items-center gap-2">
      <dt className="shrink-0">{term}</dt>
      <dd className="text-beam-text-muted">{children}</dd>
    </div>
  );
}
